"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = exports.Prefab = exports.Context = exports.Config = exports.prefab = void 0;
const prefab_1 = require("./src/prefab");
Object.defineProperty(exports, "prefab", { enumerable: true, get: function () { return prefab_1.prefab; } });
Object.defineProperty(exports, "Prefab", { enumerable: true, get: function () { return prefab_1.Prefab; } });
const config_1 = require("./src/config");
Object.defineProperty(exports, "Config", { enumerable: true, get: function () { return config_1.Config; } });
const context_1 = __importDefault(require("./src/context"));
exports.Context = context_1.default;
const version_1 = __importDefault(require("./src/version"));
exports.version = version_1.default;
